module.exports = __webpack_public_path__ + "img/icon-reward@2x.27a6d531.png";